import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20composition%20with%20sneakers%20hoodies%20and%20accessories%20floating%20elegantly%20on%20warm%20cream%20beige%20background%2C%20soft%20dreamy%20natural%20daylight%2C%20editorial%20high%20fashion%20product%20photography%2C%20minimal%20Scandinavian%20aesthetic%2C%20gentle%20ethereal%20atmosphere%2C%20high%20detail%2C%20organic%20textures%2C%20sophisticated%20lifestyle%20concept%2C%20airy%20and%20refined%20composition&width=1600&height=900&seq=kakobuy-hero-v3-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska - moda i produkty"
          title="Kakobuy Spreadsheet Polska - najlepsze produkty"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
          Kakobuy Spreadsheet Polska –<br />
          <span className="text-accent-300">Znajdź najlepsze produkty szybciej</span>
        </h1>

        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Kompletna baza produktów, linków i poradników Kakobuy.
          Przeglądaj sprawdzone znaleziska, analizuj jakość QC i oszczędzaj czas podczas zakupów.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-foreground-950 font-label font-semibold text-sm hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-fire-line text-lg"></i>
            Otwórz Kakobuy Spreadsheet
          </a>
          <Link
            to="/artykul/kakobuy-spreadsheet-polska-poradnik"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-white/30 text-white font-label font-semibold text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-book-open-line"></i>
            Dowiedz się jak działa Kakobuy
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5">
          {[
            { icon: 'ri-checkbox-circle-line', text: 'Aktualizowane listy produktów' },
            { icon: 'ri-global-line', text: 'Polska instrukcja zakupów' },
            { icon: 'ri-user-star-line', text: 'Poradniki dla początkujących' },
            { icon: 'ri-shield-check-line', text: 'System sprawdzania jakości QC' },
          ].map((badge) => (
            <span
              key={badge.text}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm text-white text-xs md:text-sm"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={badge.icon}></i>
              </span>
              {badge.text}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}